import { KatLitFilteredElement, register } from '../../shared/base';
import { KatMetric } from './';

/**
 * @component {kat-metric-actions} KatMetricActions Component used to place and filter actions within the metric component.
 */
@register(KatMetric.slotMapping.actions.name)
export class KatMetricActions extends KatLitFilteredElement {
  constructor() {
    super(
      KatMetric.slotMapping.actions.name,
      KatMetric.slotMapping.actions.allowed
    );
  }
}
